<alg-input
  class="transparent search-placeholder"
  inputIcon="ph-duotone ph-magnifying-glass"
  i18n-placeholder placeholder="Search ?"
  name="search"
  [parentForm]="form"
></alg-input>
